import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const DETAIL_USER_MANAGEMENT_OK = "DETAIL_USER_MANAGEMENT_OK";
export const DETAIL_USER_MANAGEMENT_ERR = "DETAIL_USER_MANAGEMENT_ERR";

export const detailUserAction = {
  detailUserManagement,
};

function DetailUserManagementOk(payload) {
  return { type: DETAIL_USER_MANAGEMENT_OK, payload };
}
function DetailUserManagementErr(payload) {
  return { type: DETAIL_USER_MANAGEMENT_ERR, payload };
}

function detailUserManagement(param) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetUserDetail, param)
      .then((response) => {
        dispatch(DetailUserManagementOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(DetailUserManagementErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
